import { createStackNavigator } from "@react-navigation/stack";
import React from "react";
import ZoneList from "../components/settings/zone/zoneList";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";
import AddUpdateZone from "../components/settings/zone/addUpdateZone";

const ZoneStack = () => {
    const ZoneStack = createStackNavigator()
    return (
        <ZoneStack.Navigator
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}
            initialRouteName="ZoneList">
            <ZoneStack.Screen name="ZoneList" component={ZoneList} />
            <ZoneStack.Screen name="addUpdateZone" component={AddUpdateZone} />
        </ZoneStack.Navigator>
    )
}
export default ZoneStack